import { Component, Input } from '@angular/core';

@Component({
  selector: 'adc-footer',
  templateUrl: './adc-footer.component.html',
  styleUrls: ['./adc-footer.component.scss'],
  standalone: false
})
export class AdcFooterComponent {
  @Input('type') type: any;
  @Input('data') data: any;
}
